import { fetchClient } from '@/util/fetchClient';

export async function deleteAwayScheduleBlockV2(id: number) {
  return fetchClient.DELETE('/v2/users/me/away-schedule/{id}', {
    params: {
      path: {
        id,
      },
    },
  });
}
